const apiUrl = import.meta.env.VITE_API_URL as string

async function apiRequest<T>(method: string, path: string, token: string, body?: unknown): Promise<T> {
  const res = await fetch(`${apiUrl}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  if (res.status === 401) throw new Error('UNAUTHORIZED')

  if (!res.ok) {
    const json = await res.json().catch(() => ({}))
    throw new Error((json as { error?: { message?: string } }).error?.message ?? `HTTP ${res.status}`)
  }

  return res.json() as Promise<T>
}

export function apiGet<T>(path: string, token: string): Promise<T> {
  return apiRequest<T>('GET', path, token)
}

export function apiPost<T>(path: string, token: string, body: unknown): Promise<T> {
  return apiRequest<T>('POST', path, token, body)
}

export function apiPatch<T>(path: string, token: string, body: unknown): Promise<T> {
  return apiRequest<T>('PATCH', path, token, body)
}
